import React from 'react';
import { Edit, SimpleForm } from 'react-admin';
import { ACCOUNT_STATUS_TO_INT, LOGGING_STATUS_TO_INT } from '@/config/constants';
import { FormPageTitle, FormToolbar } from '@/components/shell';
import { AccountFields } from './AccountFields';
import type { AccountRecord } from './types';

const BACK_TO = '/accounts';

const transform = (data: AccountRecord) => {
  const acc = data.accountResponse || {};
  return {
    accountName: acc.accountName,
    apiKey: acc.apiKey || '',
    accountStatus: ACCOUNT_STATUS_TO_INT[acc.accountStatus ?? ''] ?? 1,
    loggingStatus: LOGGING_STATUS_TO_INT[acc.loggingStatus ?? ''] ?? 1,
    allowDebugOutput: acc.allowDebugOutput || false,
    rateLimitApplies: acc.rateLimitApplies || false,
    whitelistApplies: false,
    rateLimitPerMin: acc.rateLimitPerMin || 0,
    rateLimitPerDay: acc.rateLimitPerDay || 0,
    primaryServerId: acc.primaryServer?.id,
    secondaryServerId: acc.secondaryServer?.id,
    licenseId: data.licenseResponse?.id,
    validityTimeFrame: data.validityTimeFrame ? new Date(data.validityTimeFrame).toISOString() : null,
    isLicenseBlocked: data.isLicenseBlocked || false,
  };
};

export const AccountEdit = () => (
  <Edit mutationMode="pessimistic" transform={transform} actions={<FormPageTitle mode="edit" />}>
    <SimpleForm toolbar={<FormToolbar backTo={BACK_TO} showDelete />}>
      <AccountFields mode="edit" />
    </SimpleForm>
  </Edit>
);
